import React from 'react';
import { HeaderPropsInterface } from './HeaderTypes';
import HeaderDesktop from './Desktop';
import HeaderMobile from './Mobile';

function Header({ isMobile }: HeaderPropsInterface) {
  function handleHeader() {
    if (!isMobile) {
      return <HeaderDesktop />;
    }

    return <HeaderMobile />;
  }

  return <>{handleHeader()}</>;
}

export default Header;
